import { ItiLink as Link } from 'components';
import { FC } from 'react';
import { LinkProps, Outlet, useLocation, useMatch, useParams, useResolvedPath } from 'react-router-dom';

import 'components/organization/tab-view/tab-view.scss';
import { useAuth } from 'contexts';
import { Role } from 'types';

const TabLink: FC<LinkProps & { to: string }> = ({ children, to }) => {
  let resolved = useResolvedPath(to);
  let match = useMatch({ path: `${resolved.pathname}`, end: true });

  return (
    <Link className={match ? 'active-tab tab' : 'tab'} to={to} replace>
      {children}
    </Link>
  );
};

const SettingsTabs: FC = () => {
  const { userProfile } = useAuth();
  const location = useLocation();
  const params = useParams();
  if (params.id || params.username || location.pathname.includes('new')) {
    return <Outlet />;
  }
  return (
    <div id="settings-page" className="page">
      <div className="page-header">
        <h1>SETTINGS</h1>
      </div>
      <div className="page-content h-100">
        <div className="tab-view h-100">
          <div className="tab-bar g-3">
            <TabLink to="/settings">
              <h3>PROFILE</h3>
            </TabLink>
            <TabLink to="/settings/users">
              <h3>USERS</h3>
            </TabLink>
            {[
              Role.ADMIN,
              Role.BILLING_ADMIN,
              Role.ADMIN_CUSTOMER,
              Role.CUSTOMER,
              Role.EXTERNAL
            ].includes(userProfile.role) && (
                <TabLink to="/settings/customers">
                  <h3>CUSTOMERS</h3>
                </TabLink>
              )}
            <TabLink to="/settings/damage-options">
              <h3>DAMAGES</h3>
            </TabLink>
            {[Role.ADMIN, Role.BILLING_ADMIN].includes(userProfile.role) && (
              <TabLink to="/settings/locations">
                <h3>LOCATIONS</h3>
              </TabLink>
            )}
            {[Role.ADMIN, Role.BILLING_ADMIN].includes(userProfile.role) && (
              <TabLink to="/settings/unit-options">
                <h3>UNIT OPTIONS</h3>
              </TabLink>
            )}
            {[Role.ADMIN, Role.BILLING_ADMIN].includes(userProfile.role) && (
              <TabLink to="/settings/size-types">
                <h3>SIZE TYPES</h3>
              </TabLink>
            )}
            {[Role.ADMIN, Role.BILLING_ADMIN].includes(userProfile.role) && (
              <TabLink to="/settings/report-groups">
                <h3>REPORTS</h3>
              </TabLink>
            )}
            {[Role.ADMIN, Role.BILLING_ADMIN].includes(userProfile.role) && (
              <TabLink to="/settings/fleet-files">
                <h3>FLEET FILES</h3>
              </TabLink>
            )}
            {[Role.ADMIN, Role.BILLING_ADMIN].includes(userProfile.role) && (
              <TabLink to="/settings/edi-dashboard">
                <h3>EDI DASHBOARD</h3>
              </TabLink>
            )}
            {[Role.ADMIN, Role.BILLING_ADMIN].includes(userProfile.role) && (
              <TabLink to="/settings/migration">
                <h3>MIGRATION</h3>
              </TabLink>
            )}
            {[Role.ADMIN, Role.BILLING_ADMIN].includes(userProfile.role) && (
              <TabLink to="/settings/contract-migration">
                <h3>CONTRACT MIGRATION</h3>
              </TabLink>
            )}
          </div>
          <div className="tab-content d-flex flex-column">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsTabs;
